export enum ContactType {

  PHONE_NUMBER= 'PHONE_NUMBER',
  MOBILE_NUMBER= 'MOBILE_NUMBER',
  EMAIL= 'EMAIL',
  WEBSITE= 'WEBSITE',
  FAX= 'FAX',
  SKYPE= 'SKYPE',
  FACEBOOK= 'FACEBOOK',
  INSTAGRAM= 'INSTAGRAM',
  TWITTER= 'TWITTER',
  YOUTUBE= 'YOUTUBE',
  SLACK= 'SLACK'

}
